<script>
export default {
  name: 'IconClose',
  functional: true,
  // eslint-disable-next-line
  render: h => (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>icon/close</title>
      <desc>Created with Sketch.</desc>
      <defs>
        <path
          d="M23.5397392,6.46026077 C24.1534203,7.0739418 24.1534203,8.06891534 23.5397392,8.68259637 L17.222,15 L23.5397392,21.3174036 C24.1534203,21.9310847 24.1534203,22.9260582 23.5397392,23.5397392 C22.9260582,24.1534203 21.9310847,24.1534203 21.3174036,23.5397392 L15,17.222 L8.68259637,23.5397392 C8.06891534,24.1534203 7.0739418,24.1534203 6.46026077,23.5397392 C5.84657974,22.9260582 5.84657974,21.9310847 6.46026077,21.3174036 L12.778,15 L6.46026077,8.68259637 C5.84657974,8.06891534 5.84657974,7.0739418 6.46026077,6.46026077 C7.0739418,5.84657974 8.06891534,5.84657974 8.68259637,6.46026077 L15,12.778 L21.3174036,6.46026077 C21.9310847,5.84657974 22.9260582,5.84657974 23.5397392,6.46026077 Z"
          id="path-6"
        />
      </defs>
      <g id="icon/close" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <mask id="mask-2" fill="white">
          <use xlinkHref="#path-6" />
        </mask>
        <use id="Mask" fill="white" xlinkHref="#path-6" />
      </g>
    </svg>
  ),
};
</script>
